@if (control) {
  <div class="form-group" [class.required]="isRequired" [formGroup]="parentForm">
    <mat-form-field [floatLabel]="'always'" appearance="fill" [class.readonly]="readOnlyCss">
      <mat-label>{{ title }}</mat-label>

      <input
        matInput
        appTrim
        appOnlyLetters
        [keepDigits]="true"
        appCapitalizeAll
        [class.is-invalid]="control.invalid && control.touched"
        type="text"
        class="form-control form-control-sm"
        [formControlName]="formControlName"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="itemSelected($event)">
        @for (option of filteredOptions | async; track option[autocompleteLabelField]) {
          <mat-option [value]="option[autocompleteLabelField]">
            {{ option[autocompleteLabelField] }}
          </mat-option>
        }
      </mat-autocomplete>

      @if (control.value && !control.errors && !hideSuccessMark) {
        <span class="success-mark">
          <fa-icon [icon]="faCheck"></fa-icon>
        </span>
      }

      @if (!hideErrorMessages) {
        <mat-error>
          @if (control.errors?.required) {
            <span>{{ requiredText }}</span>
          }
          @if (control.errors?.noDigitsValidator) {
            <!-- Le nom de la ville ne peut pas contenir de chiffres. -->
            <span>{{ 'Common.CityNoDigitsError' | labelText }}</span>
          }
          @if (control.errors?.maxlength) {
            <span>
              {{ 'HOME.WrongEntryErrorText1' | labelText }} {{ maxLength }} {{ 'HOME.WrongEntryErrorText2' | labelText }}
            </span>
          }
        </mat-error>
      }
    </mat-form-field>
  </div>
}
